<template>
  <div>
    <modal-cadu close :width="1131.52" v-model="showModal">
      <div slot="all" class="py-10 px-10">
        <div slot="header" class="primary1--text headline font-weight-bold">Histórico</div>
        <div slot="body">
          <component-loading :value="isLoadingTableHistorico" />

          <TableHistorico
            :objetoSelos="selosTable"
            :rows="rowsConteudo"
            :pagina="pagina"
            :qtPaginas="qtPaginas"
            :listaSelosBloqueados="listaSelosBloqueados"
            v-if="!isLoadingTableHistorico"
            @visualizar="(obj) => visualizarElemento(obj)"
            @editar="(obj) => editarElemento(obj)"
            @excluir="(obj) => excluirElemento(obj)"
          />
        </div>
      </div>
    </modal-cadu>

    <SucessoModal
      :showSucess="showSucess"
      sucessType="EDIT"
      successName="Certificado/Selo"
      @close="showSucess = false"
    />

    <ErrorModal v-model="showError" :errObj="errObj" />

    <ModalCertificacao
      ref="modalCertificacao"
      v-model="showModalCertificacao"
      :seloCertificado="seloCertificadoSelecionado"
      :action="action"
      @save-certificacao-selo="atualizarCertificacaoSelo"
      @close="abrirNovamenteHistorico"
    />

    <ExcluirModal
      :text="'Tem certeza que deseja excluir essa certificação/selo?'"
      :showDelete="showDelete"
      @close="abrirNovamenteHistorico"
      @confirmDelete="deletarCertificacaoSelo()"
    />

    <overlay-loading v-model="loadingOverlay" />
  </div>
</template>

<script>
import TableHistorico from './TableHistorico'
import Selo from '../../../../../services/Selos/Selo'
import ModalCertificacao from './ModalCertificacao'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    TableHistorico,
    ModalCertificacao,
    ErrorModal
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    listaSelosBloqueados: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showModal: this.value,
      historico: [],
      isLoadingTableHistorico: false,
      loadingOverlay: false,
      selosTable: {},
      rowsConteudo: [],
      elementsPerPage: '5',
      pagina: -1,
      qtPaginas: -1,
      qtResultados: -1,
      tipoDeVigencia: 'VIGENTE',
      argsPadrao: `ordenacao=dataFim&direcaoOrdenacao=desc&tamanhoPagina=5&pagina=1&vigencia=TODOS`,

      showSucess: false,
      seloCertificadoSelecionado: {},
      showModalCertificacao: false,
      action: 'edit',

      // Error Modal
      showError: false,
      errObj: { error: 'Error' },

      selosIdsExcluir: [],
      showDelete: false
    }
  },
  beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.opcaoEditar = JSON.parse(localStorage.getItem('optionEdit'))
  },
  methods: {
    async getSelos(args) {
      this.isLoadingTableHistorico = true

      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo
        .getSelo(args)
        .then((responseSelo) => {
          this.rowsConteudo = responseSelo.data.conteudo
          this.pagina = responseSelo.data.pagina
          this.qtPaginas = responseSelo.data.qtPaginas
          this.qtResultados = responseSelo.data.qtResultados
          this.isLoadingTableHistorico = false
        })
        .catch((err) => {
          console.error(err.response.data.message)
          this.showError = true
          this.errObj.error = err.response.data.message
        })
    },
    async atualizarCertificacaoSelo(obj) {
      this.loadingOverlay = true
      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo
        .putSelo(obj)
        .then(() => {
          this.getSelos(this.argsPadrao)
          this.showSucess = true
          EventBus.$emit('carregarCertificacoes', true)
          EventBus.$emit('resolverAlertaNotificaoPendente', { tipoNotificacao: 'CERTIFICADO_VENCIDO' })
        })
        .catch((err) => {
          console.error(err.response)
          this.showError = true
          this.errObj.error = err.response.data.message
        })
        .finally(() => {
          this.loadingOverlay = false

          this.showModal = true
          this.showModalCertificacao = false
        })
    },
    visualizarElemento({ obj, action }) {
      this.action = action
      this.seloCertificadoSelecionado = obj
      this.showModal = false
      this.showModalCertificacao = true
    },
    editarElemento({ obj, action }) {
      this.action = action
      this.seloCertificadoSelecionado = obj
      this.showModal = false
      this.showModalCertificacao = true
    },
    excluirElemento(obj) {
      this.selosIdsExcluir = obj
      this.showModal = false
      this.showDelete = true
    },
    abrirNovamenteHistorico() {
      this.showModal = true
      this.showDelete = false
    },
    async deletarCertificacaoSelo() {
      this.loadingOverlay = true
      this.showDelete = false

      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo
        .delSelos(this.selosIdsExcluir)
        .then((res) => {
          this.messageANS = 'Certificação/Selo excluído com sucesso!'

          this.loadingOverlay = false
          this.showSucess = true
        })
        .catch((err) => {
          console.error(err)
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message

          this.loadingOverlay = false
          this.showError = true
        })
        .finally(() => {
          this.getSelos()
          this.$emit('listar-ativos')
        })
    }
  },
  watch: {
    showModal() {
      if (!this.showModal) {
        this.$emit('input', false)
      } else {
        this.getSelos(this.argsPadrao)
      }
    },
    value() {
      this.showModal = this.value
    }
  }
}
</script>

<style></style>
